import { Avatar, Flex, Typography, theme } from 'antd';

interface AvatarLabelCellProps {
  /** Display text shown beside the avatar (also used as the ellipsis tooltip). */
  label: string;
  /** Optional square artwork; omitted when falsy. */
  imageUrl?: string | null;
}

/**
 * Compact table cell: optional square avatar + ellipsis label.
 */
export const AvatarLabelCell = ({ label, imageUrl }: AvatarLabelCellProps) => {
  const { token } = theme.useToken();

  return (
    <Flex align="center" gap={8} style={{ width: '100%', minWidth: 0 }}>
      {imageUrl ? (
        <Avatar
          shape="square"
          size={token.controlHeightLG}
          src={imageUrl}
          style={{ flexShrink: 0 }}
        />
      ) : null}
      <Typography.Text ellipsis={{ tooltip: label }} style={{ flex: 1, minWidth: 0 }}>
        {label}
      </Typography.Text>
    </Flex>
  );
};
